// BranchUserDashboard.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FaCreditCard, FaHistory, FaCog } from "react-icons/fa";
import './BranchUserDashboard.css';

const BranchUserDashboard = () => {
  const [userBal, setUserBal] = useState('');
  const [dashboardData, setDashboardData] = useState(null);
  const [superAdminName, setSuperAdminName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [orgDetails, setOrgDetails] = useState(null);
  const navigate = useNavigate();
  const [IsLoading, setIsLoading] = useState(false);

  const fnbranchUserTransactions = (e) => {
    navigate("/BranchUser/TransactionHistory");
  };

  const fnbranchCardManagement = (e) => {
    navigate("/BranchUser/CardManagement");
  };

  useEffect(() => {
    let TokenVal = localStorage.getItem('jwtToken');
    fnDashboardLoad();
    if (TokenVal === null || TokenVal === "" || TokenVal === undefined) {
      navigate("/");
    }
    getOrgInfo();
  }, []);

  function getOrgInfo() {
    const BASE_URL = window.BASE_URL + '/get_organizationinfo';
    const data = JSON.stringify({
      "organization_id": parseInt(localStorage.getItem('org_id')),
    });
    const token = localStorage.getItem("jwtToken");
    const config = {
      method: "post",
      url: BASE_URL,
      headers: {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
      data: data
    };
    setIsLoading(true);
    axios.request(config)
      .then((response) => {
        if (response?.data) {
          setOrgDetails(response.data.results[0]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching organization info:", error);
        setIsLoading(false);
      });
  }

  function fnDashboardLoad() {
    const BASE_URL = window.BASE_URL + '/get_dashboardInfo';
    var config = {
      method: 'get',
      url: BASE_URL,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    };
    axios.request(config)
      .then(function (response) {
        if (response?.data?.results) {
          const data = response.data.results;
          setDashboardData(data);
          setUserBal(data.userBalance);
          if (data.userInfo) {
            setSuperAdminName(data.userInfo.name);
            setMobileNumber(data.userInfo.mobile);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const progressPercentage = dashboardData && dashboardData.allUserTransactions?.AGENT
    ? Math.min(100, Math.round((dashboardData.totalCardsRechargeAmount || 0) / dashboardData.allUserTransactions.AGENT * 100))
    : 4;

  return (
    <div className="dashboard-container">
      {/* Loader */}
      {IsLoading && (
        <div className="loader-overlay">
          <div className="loader-box">
            <div className="spinner"></div>
            <p className="loader-text">Loading...</p>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <h1 className="header-title">Dashboard</h1>
        </div>
      </div>

      <div className="dashboard-main">
        {/* Agent Info & Balance Card */}
        <div className="agent-card">
          <div className="agent-grid">
            <div className="agent-info">
              <p className="agent-label">Agent Name</p>
              <h2 className="agent-name">{superAdminName}</h2>
              <div className="agent-mobile-section">
                <span>Mobile</span>
                <div className="agent-mobile">{mobileNumber}</div>
              </div>
            </div>
            <div className="balance-section">
              <p className="balance-label">Balance Units</p>
              <h2 className="balance-amount">{userBal}</h2>
            </div>
          </div>
        </div>

        {/* Overall Progress & Today's Stats Side by Side */}
        <div className="stats-container">
          {/* Overall Progress Section */}
          <div className="progress-card">
            <h3 className="section-title">Overall Progress</h3>
            <div className="progress-grid">
              <div className="progress-circle-wrapper">
                <div className="progress-circle">
                  <svg className="progress-svg">
                    <circle
                      cx="60"
                      cy="60"
                      r="52"
                      stroke="#e5e7eb"
                      strokeWidth="10"
                      fill="none"
                    />
                    <circle
                      className="progress-bar"
                      cx="60"
                      cy="60"
                      r="52"
                      stroke="#f97316"
                      strokeWidth="10"
                      fill="none"
                      strokeDasharray={`${progressPercentage * 3.267} 326.7`}
                      strokeLinecap="round"
                    />
                  </svg>
                  <div className="progress-text">
                    <span className="progress-percentage">{progressPercentage}%</span>
                    <span className="progress-label">CARD</span>
                    <span className="progress-fraction">
                      {dashboardData?.totalCardsRechargeAmount || 0}/{dashboardData?.allUserTransactions?.AGENT || 0}
                    </span>
                  </div>
                </div>
              </div>
              <div className="cards-issued-section">
                <p className="cards-issued-label">Total Cards Issued</p>
                <p className="cards-issued-number">{dashboardData?.totalCardsIssued || 0}</p>
              </div>
            </div>
          </div>

          {/* Today's Stats */}
          <div className="today-card">
            <h3 className="section-title">Today's</h3>
            <div className="today-grid">
              <div className="today-section">
                <p className="today-heading">Recharges</p>
                <div className="today-stats">
                  <div className="stat-item">
                    <p className="stat-label">Cards</p>
                    <div className="stat-values">
                      <span className="stat-primary stat-green">
                        {dashboardData?.todaysCardsRecharged || 0}
                      </span>
                      <span className="stat-secondary">
                        ({dashboardData?.todaysRecharges || 0})
                      </span>
                    </div>
                  </div>
                  <div className="stat-item">
                    <p className="stat-label">Swap</p>
                    <div className="stat-values">
                      <span className="stat-primary">
                        {dashboardData?.todayCardSwaps || 0}
                      </span>
                      <span className="stat-secondary">
                        ({dashboardData?.todaySwapAmount || 0})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="today-section">
                <p className="today-heading">Cards</p>
                <div className="stat-item">
                  <p className="stat-label">Issued</p>
                  <span className="stat-primary">
                    {dashboardData?.totalCardsIssuedToday || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Organization Details */}
        <div className="org-card">
          {!orgDetails ? (
            <div className="org-loading">Loading...</div>
          ) : (
            <div
              className="org-content"
              onClick={() => navigate(`/BranchUser/ManageBranch/${localStorage.getItem('branch_id')}/${localStorage.getItem('org_id')}`)}
            >
              <div className="org-row">
                <span className="org-label">Organization : </span>
                <span className="org-value">{orgDetails.name}</span>
              </div>
              <div className="org-row">
                <span className="org-label">Branch : </span>
                <span className="org-value">Test Branch</span>
              </div>
              <div className="org-row">
                <span className="org-label">Mobile 1 : </span>
                <span className="org-value">{orgDetails.mobile_1}</span>
                <span className="org-label org-label-inline">Mobile 2 : </span>
                <span className="org-value">{orgDetails.mobile_2}</span>
              </div>
              <div className="org-row">
                <span className="org-label">Email : </span>
                <span className="org-value">{orgDetails.email}</span>
              </div>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button onClick={fnbranchCardManagement} className="action-btn">
            Card Management
          </button>
          <button onClick={fnbranchUserTransactions} className="action-btn">
            User Transactions
          </button>
        </div>

        {/* Settings Button */}
        <button className="settings-fab">
          <FaCog className="settings-icon" />
        </button>
      </div>
    </div>
  );
};

export default BranchUserDashboard;